import React from 'react';
import { Link } from 'gatsby';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import CategoriesDropDown from './categoriesDropDown';
import menuPaths from '../constants/menuPaths';

import styles from '../styles/components/menuWide.module.scss';

const MenuWide = ({ intl }) => {
  const language = intl.locale;
  const aboutUsPath = `/${language}/${menuPaths.aboutUs[language]}`;
  const contributePath = `/${language}/${menuPaths.contribute[language]}`;

  return (
    <nav className={styles.container}>
      <ul className={styles.menuWide}>
        <li>
          <CategoriesDropDown />
        </li>
        <li>
          <Link to={aboutUsPath} activeClassName={styles.activeLink}>
            <FormattedMessage
              id="menu.aboutUs"
            />
          </Link>
        </li>
        <li>
          <Link to={contributePath} activeClassName={styles.activeLink}>
            <FormattedMessage
              id="menu.contribute"
            />
          </Link>
        </li>
      </ul>
    </nav>
  );
};

MenuWide.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(MenuWide);
